export default __webpack_public_path__ + "images/d2922d22b60e76ea1df94dce05453059.png";